import React from 'react';
import Box from '../utils/Box';

const EditorBlockContainer = props => (
  <Box my={3} mx={2} bg="white" boxShadow={0} borderRadius={0} {...props} />
);

export default EditorBlockContainer;
